<template>
  <div class="banquet-order"
       v-if="columns.length">
    <div class="detail">
      <span class="title">宴席原始数据</span>
      <div class="item"
           v-for="field in displayFields"
           :key="field.label">
        <span class="label">{{ field.label }}</span>
        <span class="value">{{ field.value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      columns: [],
      // source 是新宴席导入表里的列名
      fieldMap: [
        {label: '宴席申报单号', source: '宴席申报单号'},
        {label: '宴席主宴时间', source: '宴席主宴时间'},
        {label: '宴席举办地省', source: '宴席举办地（省）'},
        {label: '宴席举办地市', source: '宴席举办地（市）'},
        {label: '宴席举办地区', source: '宴席举办地（区）'},
        {label: '经纬度解析', source: '宴席举办地（经纬度解析）'},
        {label: '宴席类型', source: '宴席类型'},
        {label: '宴席用酒品牌', source: '宴席用酒品牌'},
        {label: '用酒品项', source: '用酒品项'},
        {label: '宴席政策', source: '宴席政策'},
        {label: '酒店名称', source: '酒店名称'},
        {label: '包间名称', source: '包间名称'},
        {label: '预计开展桌数', source: '预计开展桌数'},
        {label: '登记用酒箱数', source: '登记用酒箱数'},
        {label: '登记用酒盒数', source: '登记用酒盒数'},
        {label: '登记用酒瓶数', source: '登记用酒瓶数'},
        {label: '登记用酒总瓶数', source: '登记用酒总瓶数'},
        {label: '退酒箱数', source: '退酒箱数'},
        {label: '退酒盒数', source: '退酒盒数'},
        {label: '退酒瓶数', source: '退酒瓶数'},
        {label: '退酒总瓶数', source: '退酒总瓶数'},
        {label: '开瓶数', source: '开瓶数'},
        {label: '追加用酒箱数', source: '追加用酒箱数'},
        {label: '追加用酒盒数', source: '追加用酒盒数'},
        {label: '追加用酒瓶数', source: '追加用酒瓶数'},
        {label: '发放核销券数量', source: '发放核销券数量'},
        {label: '核销核销券数量', source: '核销核销券数量'},
      ],
    }
  },
  computed: {
    ...Vuex.mapState({
      orderDetail: state => state.orderReview.orderDetail,
    }),
    displayFields () {
      const byLabel = {}
      this.columns.forEach(function (column) {
        byLabel[column.label] = column.value
      })
      return this.fieldMap.map(function (field) {
        const value = byLabel[field.source]
        return {
          label: field.label,
          value: value === '' || value === null || value === undefined ? '-' : value,
        }
      })
    },
  },
  watch: {
    'orderDetail.taskid': {
      immediate: true,
      handler (taskid) {
        this.load(taskid)
      },
    },
  },
  methods: {
    load (taskid) {
      if (!taskid) {
        this.columns = []
        return
      }
      request.common('banquetTaskByTask', {id: taskid}).then(({data}) => {
        this.columns = (data && data.columns) || []
      }).catch(() => {
        this.columns = []
      })
    },
  },
}
</script>

<style scoped>
.detail {
  background-color: #ecf5ff;
  padding: 8px;
  border-radius: 6px;
}
.title {
  display: inline-block;
  margin-top: 12px;
  font-size: 14px;
  font-weight: bold;
}
.item {
  margin: 8px 0;
  display: flex;
  flex-direction: row;
}
.label {
  display: inline-block;
  font-size: 14px;
  width: 110px;
  color: #666;
}
.value {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/views/order-review/components/BanquetOrderDetail.vue